export default "__VITE_ASSET__DxKCwZNV__"